import { useMemo } from "react";
import { Button, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { simpleDiagnoseStorage } from "../../../utils/storage";

interface Props {
  isDispComparisonButton?: boolean;
  isDispResultDetails?: boolean;
}

export const EstimatePremium = ({ isDispComparisonButton = true }: Props) => {
  const navigate = useNavigate();

  const { request: simpleDiagnoseFilter } = useMemo(
    () => simpleDiagnoseStorage.get(),
    []
  );

  const onCompare = () => {
    navigate(
      `/comparison?age=${simpleDiagnoseFilter.age}&sex=${simpleDiagnoseFilter.sex}`
    );
  };

  return (
    <section>
      <div className="cardWrapper">
        <div className="cardContainer">
          {isDispComparisonButton ? (
            <Stack style={{ marginTop: "40px" }}>
              <Button
                variant="blue"
                className="p-3"
                style={{ borderRadius: 12 }}
                onClick={onCompare}
              >
                保険商品を比較してみる
              </Button>
            </Stack>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default EstimatePremium;
